<template>
  <div :class="['container', { 'container-dark': theme_dark }]">

    <div class="nav-top">
          <div class="nav-left" @click="back()">
            <img src="../assets/img/返回箭头.png" class="nav-img" />
            <span class="nav-lable"></span>
          </div>
          <div class="nav-middle">最近在线</div>
          <div class="nav-right">
            <span class="nav-lable"></span>
            <img src="../assets/img/返回箭头.png" class="nav-img none" />
          </div>
    </div>


    <ul class="recommend-section">
     <li class="user-card" v-for="(item, index) in least_user" :key="index">
       <div class="user-info">
         <div class="avatar">
           <img v-if="item.photo" :src="item.photo" alt="" />
         </div>
         <div class="details">
           <div class="information1">
             <span>{{ item.nick.length > 8 ? item.nick.substr(0,7) + '...' : item.nick }}</span>
             <div class="age-range">
               <img v-if="item.sex == '男生'" src="../assets/img/男.png" alt="#"/>
               <img v-if="item.sex == '女生'" src="../assets/img/女.png" alt="#"/>
               <span>{{ item.age_range }}</span>
             </div>
           </div>
           <div class="information2">
             <div class="crad-value">
               <span>魅力值 {{ item.score_total }}</span>
             </div>
             <div class="crad-value">
               <span>豪气值 {{ item.coin_total }}</span>
             </div>
           </div>
           <div class="details-state">{{ item.dtm_sp }}前</div>
         </div>
       </div>
       <div class="match-button" @click="buildChart(item.uid)">
         <span>撩ta</span>
         <div class="love">
           <img class="love-icon" src="../assets/img/new2024/love.png" alt="#"/>
         </div>
       </div>
     </li>
     <div style="height: 2rem;"></div>
    </ul>

    <dlg ref="myForm_buyVip" @formBehavior="formact_buyVip"></dlg>
  </div>
</template>
<script>
import * as tool from "../api/common";
import { mapMutations, mapActions } from "vuex";
import Form from "../components/Form.vue";
export default {
  components: {
    dlg: Form,
  },

  data() {
    return {
      userinfo: {
        vip_level: 0,
      },
      theme_dark: false
    };
  },
  computed: {
    least_user: function() {
       var data = this.$store.state.least_online;
       data = this.format_online(data);
       return data;
     }
  },
  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    this.init_page();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    ...mapActions(["act_get_userinfo"]), //引入方法

    back() {
      this.$router.go(-1); //返回上一层
    },

    init_page() {
      //拉取最新在线用户
      this.get_least_user();

      var uid = this.$store.state.uid;
      if (uid) {
        this.init_user(uid);
      }
    },

    init_user(uid) {
      var self = this;
      self.act_get_userinfo({
        uid: uid,
        success: function (u) {
          self.userinfo.vip_level = u.vip_level;
        },
      });
    },

    //获取最近在线用户数据
    get_least_user() {
      var least_cur = [];
      var least_pre = this.$store.state.least_online;

      var uid = this.$store.state.uid;
      var dtm_start = "";
      var count = 8;

      if (least_pre.length > 0) {
        least_cur = least_cur.concat(least_pre);
        dtm_start = least_pre[0].dtm;
        if (least_pre.length > 8) {
          count = 4;
        }
      }

      //根据时间间隔控制是否需要到后台获取最新数据
       var tsp = tool.dateDiff2(new Date(dtm_start), new Date());
       if (tsp < 30) {
         return false;
       }

      var self = this;
      self.get({
        url:
          "/App/GetLeastOnlineUser/?uid=" +uid +"&dtm_start=" + dtm_start + "&count=" + count,
        success: function(data) {
          //console.log(JSON.stringify(data));
          if (data) {
            var dtm = new Date();
            for (var i in data) {
              var user_item = data[i];

              //存在，则先删除
              var idx = tool.hasKey(least_cur, user_item.uid, "uid");
              if (idx >= 0) {
                least_cur.splice(idx, 1);
              }

              user_item.photo = self.$store.state.url + "/photo/" + user_item.photo;
              user_item.dtm = dtm.Format("yyyy/MM/dd hh:mm:ss");
              user_item.dtm_sp = "1秒";

              //再添加
              least_cur.push(user_item);
            }
            self.$store.commit("push_least_online", least_cur);
            //self.$store.dispatch('act_set_online_count', least_cur.length);
          }
        },
        error: function(res) {}
      });
    },

    //撩按钮，跳转到聊天
    buildChart(uid) {
      this.check_uid();

      if (this.checkVip("此功能是会员特权功能，成为会员即刻随意撩~Ta")) {
        this.goto_chart(uid);
      }
    },

    //检查uid，没有获取到重新加载页面
    check_uid(){
      var uid = this.$store.state.uid;
      console.log("首页检查uid是否获取成功,uid:" + uid);

      if(!uid){
        //刷新页面，仅在微信环境下进行刷新
        var client = this.$store.state.client;
        if (client.is_wx) {
          window.location.reload(true);
        }
      }
    },

    //根据uid跳转到对应的聊天
    goto_chart(uid) {
      this.$router.push({ name: "chart", params: { uid: uid } });
    },

    checkVip(msg) {
      var b = true;
      var vip_level = this.userinfo.vip_level;
      console.log(vip_level);
      if (vip_level == 0) {
        //购买会员提示
        this.$refs.myForm_buyVip.show(msg, {
          type: "confirm",
          confirmText: "升级会员",
          titleText: "温馨提示",
          data: ""
        });
        return false;
      }
      return b;
    },

    formact_buyVip(type, data) {
      //console.log(type);
      if (type == "clickConfirm") {
        this.$router.push({ name: "vip_center" });
      }
    },

    format_online: function(data) {
      //处理数据，增加时间戳
      for (var i in data) {
        var dtm = new Date(data[i].dtm);
        var dtm_now = new Date();
        var sp = tool.dateDiff(dtm, dtm_now);
        if (sp == "0秒") {
          sp = "1秒";
        }
        data[i].dtm_sp = sp;
      }
      //排序
      data = tool.arry_sort(data, "dtm", "dtm_desc");
      return data;
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background-color: #EFEFEF;
  background-size: 100% 100%;
}
.recommend-section {
  flex: 1;
  overflow-y: auto;
  scrollbar-width: none; /* firefox 不显示滚动条 */
  -ms-overflow-style: none; /* IE 10+ 不显示滚动条 */
  padding: 0.5rem;
  .user-card {
    height: 5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(to right, #1f1b2a, #67598e);
    padding: 0.4rem;
    border-radius: 0.62rem;
    margin-bottom: 0.62rem;
    .user-info {
      display: flex;
      align-items: center;
      color: #fff;
      .avatar {
        margin-right: 0.62rem;
        img {
          width: 3.5rem;
          height: 3.5rem;
          border-radius: 50%;
        }
      }
    }
    .match-button {
      background: linear-gradient(#8a61ff, #fe9cc0);
      color: white;
      border: none;
      border-radius: 2rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      span {
        font-size: 0.9rem;
        margin-left: 1rem;
        margin-right: 0.5rem;
      }
      .love {
        width: 2rem;
        height: 2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        border: 1px solid #fff;
        background: linear-gradient(#8a61ff, #fe9cc0);
        img {
          margin-top: 0.5rem;
          margin-left: 0.1rem;
          width: 1.5rem;
          height: 1.5rem;
        }
      }
    }
  }
}
.details {
        height: 5rem;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
          .information1 {
            display: flex;
            align-items: center;
            .age-range {
              padding:1px 2px;
              border: 1px solid #999;
              border-radius: 3px;
              font-size: 0.7rem;
              margin-left: 0.5rem;
              display: flex;
              justify-content:space-evenly;
              align-items: center;
              img {
                width: 0.8rem;
                height: 0.8rem;
              }
              span {
                font-size: 0.6rem;
              }
            }
            span{
              font-size: 0.9rem;
            }
          }
          .information2 {
            display: flex;
            .crad-value {
              display: flex;
              justify-content: center;
              align-items: center;
              margin-right: 0.7rem;
              padding:1px 2px;
              border-radius:3px;
              border:1px solid #dcdcdc;
              span {
                font-size: 0.6rem;
              }
            }
            
          }
          .details-state {
            color: rgba(255, 255, 255, 0.5);
            font-size: 0.7rem;
          }
}

.recommend-section::-webkit-scrollbar {
  display: none; /* Chrome Safari 不显示滚动条 */
}



.container-dark {
  min-height: 100vh;
  background-color: #2F2E33;
}
</style>
